import Service from '@/helpers/service'

export default {

    get(page, params) {
        return Service().get('MRPTypes?page=' + page,  {params});
    }, 
    show(id) {
        return Service().get('MRPTypes/show/'+id);
    },    
    create(params) {
        return Service().post('MRPTypes/create', params);
    },
    update(id, params) {
        return Service().post('MRPTypes/update/'+id, params);
    },
    delete(id) {
        return Service().post('MRPTypes/delete/'+id);
    }
}